<script setup lang="ts">
import { VIcon } from '@/modules/shared/components'

const props = defineProps<{
  text?: string
  tooltipId?: string
}>()
</script>

<template>
  <div class="group relative inline-flex hover:block" tabindex="0">
    <div
      class="rounded-full border-none bg-white font-medium text-gray-700 shadow-sm ring-1 ring-gray-700/20 hover:shadow-md hover:ring-gray-700/30 active:shadow-sm"
    >
      <VIcon name="Help" class="h-5 w-5 text-gray-700" />
    </div>
    <div
      class="absolute bottom-full left-1/2 hidden w-80 -translate-x-1/2 transform pb-1 group-focus-within:block group-hover:block"
    >
      <div
        :id="tooltipId"
        class="rounded-md bg-gray-900/90 px-4 py-4 text-sm font-medium text-gray-100 shadow-lg backdrop-blur"
        role="tooltip"
      >
        <slot>{{ text }}</slot>
      </div>
    </div>
  </div>
</template>
